export const WHEN_TO_USE = `Apply conditional formatting — set the colour of the
components and references currently visible in the view based on conditions. Only
use this when the user asks to colour, highlight, or visually distinguish
entities in the view by some condition (e.g. "colour all applications red",
"highlight components where criticality is high", "dim everything that is not a
database"). It changes colour only — not labels, icons, grouping or data
contents. Only use this to encode visualized information by colour.`;

export const FORMATTING_CONTEXT_DESCRIPTION = `The context provides:
'summary' — the data currently visible in the view: component and reference
types, each with their fields and per-field distributions ('enum' carries
'topValues'; 'numeric' carries min/max/mean; 'date' carries min/max; 'text' is
long free-form, so avoid exact-match comparators on it; 'opaque' has no
distribution, so only emptiness checks are reliable).

A field whose name joins two field names with a comma (for example
'active_period_start_date,active_period_end_date') is a date range made of a
start and an end field. Use its 'dateRange…' comparators on it, and the plain
date comparators on the start and end fields themselves.

Use it to read what the user means. Unless the user states an explicit
condition, a thing they name is either a type, an entity, or an entity attribute
— resolve it against this data in order: first match the type names, then the
entity values in 'topValues'. If specific entities or values match (e.g. "Google" → components
whose 'name' is "Google"; "Google apps" → components of type "Application" whose
'name' contains "Google"; "critical" → a 'criticality' field value), make a
condition on that field, scoped with 'affectsTypeNames' when a type is also named.
If only a type matches with no specific entities (e.g. "apps" → 'Application'),
colour that whole type with one rule whose 'name' is "type", 'comparator' is
"idMatch", and 'value' is the type's name. If neither a type nor any entities
match, ask the user what they mean instead of guessing.

'currentRules' — the conditional-formatting rules already applied to the view. A
system-filter rule among them means the view is already dimmed: keep it to leave
the dimming on, drop it to restore the colours of the entities no rule matches.

'componentTypeNamesWithAncestors' — the types of the visible components and of
the components above them in the hierarchy. A type of a component above the
visible ones has no entry in 'summary', but a component rule may colour by it.

'availableTagNames' — the tags a tag rule may use. A tag rule's 'value' must be
exactly one of them; if the user names a tag that is not listed, use the closest
listed tag or tell them it does not exist instead of guessing. Never emit a tag
rule with an empty 'value'.

A new or changed rule that colours by type must name a type from the list matching
what it affects: a component rule a type from 'summary.componentTypes' or
'componentTypeNamesWithAncestors', a reference rule a type from
'summary.referenceTypes'. Rules copied unchanged from 'currentRules' are not
checked against it.`;
